import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page04',
  templateUrl: './armenia-page04.component.html',
  styleUrls: ['./armenia-page04.component.css']
})
export class ArmeniaPage04Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
